import * as React from "react";

import { cn } from "src/lib/utils";

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<"textarea">>(({ className, ...props }, ref) => (
	<textarea
		ref={ref}
		className={cn(
			"tw-flex tw-min-h-[84px] tw-w-full tw-rounded-[10px] tw-border tw-border-border tw-bg-white tw-px-3 tw-py-2 tw-text-[14px] tw-text-text tw-transition-colors",
			"placeholder:tw-text-text-soft focus-visible:tw-outline-none focus-visible:tw-border-teal focus-visible:tw-ring-2 focus-visible:tw-ring-teal/20",
			"disabled:tw-cursor-not-allowed disabled:tw-bg-slate-tint disabled:tw-opacity-60",
			className
		)}
		{...props}
	/>
));
Textarea.displayName = "Textarea";

export { Textarea };
